import { Button, Flex, FormCheckbox, Text } from '@spotify-internal/encore-web';
import { ConfidenceWebsiteLinkEncore } from '@spotify/confidence-core-react';

import { useCreateAccountFormContext } from './CreateAccountFormProvider';

export const CreateWorkspaceFooter = () => {
  const {
    canSubmit,
    acceptMarketingEmails,
    setAcceptMarketingEmails,
    handleCreate,
  } = useCreateAccountFormContext();
  return (
    <Flex direction="column" gap="tighter">
      <Text variant="bodySmall" semanticColor="textSubdued">
        By clicking &quot;Create workspace&quot;, you confirm that you have read
        and agree to the{' '}
        <ConfidenceWebsiteLinkEncore route="/terms-of-service">
          Terms of Service
        </ConfidenceWebsiteLinkEncore>
        .
      </Text>
      <Button
        variant="primary"
        size="large"
        fullWidth
        disabled={!canSubmit}
        onClick={handleCreate}
      >
        Create workspace
      </Button>
      <FormCheckbox
        id="marketing-emails"
        name="marketing-emails"
        size="small"
        checked={acceptMarketingEmails}
        onChange={() => setAcceptMarketingEmails(!acceptMarketingEmails)}
      >
        Send me tips and updates to help me get started with Confidence
      </FormCheckbox>
    </Flex>
  );
};
